import type { JSX } from 'react';

import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

export const NewReleaseIcon = (props: SVGProps): JSX.Element => {
  return <SpriteIcon spriteId="announcement" {...props} />;
};
